<template>
    <div>
        <h1>404 page not found</h1>
        <p>Try something else or contact administrator</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
<style lang="scss">
</style>